import { STATUS } from "@/constants/statuses";
import RewardsEarnPointsApiService from "@apps/rewards/modules/EarnPoints/api_service/RewardsEarnPointsApiService";
import RewardsEarnPointsStore from "@apps/rewards/modules/EarnPoints/store/RewardsEarnPointsStore";
import type { Observable } from "rxjs";
import { catchError, finalize, tap } from "rxjs";
import { inject, injectable } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

import { rewardsApplicationLoggerToken } from "../../../tokens";
import type { EarnPointsEntity } from "../models/RewardsEarnPointsEntity";

@injectable()
class RewardsEarnPointsService {
    constructor(
        @inject(rewardsApplicationLoggerToken)
        private readonly logger: LoggerInterface,
        private readonly earnPointsApiService: RewardsEarnPointsApiService,
        private readonly earnPointsStore: RewardsEarnPointsStore
    ) {}

    public getAmountForProduct(
        productId: number
    ): Observable<EarnPointsEntity> {
        this.logger.debug(
            "RewardsEarnPointsService.getAmountForProductObservable is started"
        );
        this.earnPointsStore.setStatus(STATUS.LOADING);

        return this.earnPointsApiService.getAmountForProduct(productId).pipe(
            finalize(() => {
                this.earnPointsStore.setStatus(STATUS.VIRGIN);
            }),
            catchError((error: unknown) => {
                this.logger.debug(
                    "RewardsEarnPointsService.getAmountForProduct is errored",
                    error
                );
                this.earnPointsStore.setStatus(STATUS.ERROR);
                throw error;
            }),
            tap((value) => {
                this.logger.debug(
                    "RewardsEarnPointsService.getAmountForProduct is ready"
                );

                //Store Update
                this.earnPointsStore.update((state) => ({
                    ...state,
                    rewardsEarnPoints: value,
                }));
                this.earnPointsStore.setStatus(STATUS.READY);
            })
        );
    }
}

export default RewardsEarnPointsService;
